module.exports = __webpack_public_path__ + "static/media/04_720.b237839c.jpeg";